import React from "react";

const ContactUs = () => {
  return (
    <>


 <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white">Contact Us</h2>
            </div>
          </div>
        </div>
      </div>


   

      {/* CONTACT SECTION */}
      <div className="shivai-contact-section">
        <div className="container">

          <div className="row">

            {/* PHONE */}
            <div className="col-md-4">
              <div className="shivai-card">
                <div className="icon-box">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <h3>Call Us</h3>
                <a href="tel:+919594849797" className="fs-4 fw-bold">+91 9594849797</a>
              </div>
            </div>

            {/* EMAIL */}
            <div className="col-md-4">
              <div className="shivai-card">
                <div className="icon-box">
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <h3>Email Us</h3>
                <a href="mailto:booking@omsaicabservice.com" className="fs- fw-bold">
                  booking@omsaicabservice.com
                </a>
              </div>
            </div>

            {/* ADDRESS */}
            <div className="col-md-4">
              <div className="shivai-card">
                <div className="icon-box">
                  <i className="fa-solid fa-location-dot"></i>
                </div>
                <h3>Our Office</h3>
                <h6>Om Sai Cab Service</h6>
                <p>Shree Vishal CHS Ltd.,
Office -13 Plot No.17, Sector 18, Kopar Khairane, Navi Mumbai, Maharashtra 400709</p>
              </div>
            </div>

          </div>

        </div>
      </div>

  




<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2871.7604903900215!2d73.0009432!3d19.1030017!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c18d6837bad9%3A0x76b9f3403b6d545d!2sOm%20Sai%20Cab%20Service%20-%20Cab%20Service%20in%20Navi%20Mumbai%20%7C%20Mumbai%20Airport%20Cab%20Service!5e1!3m2!1sen!2sin!4v1778847103556!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

    </>
  );
};

export default ContactUs;